/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrBalloonEntity } from '../../models/dbr-balloon-entity';

export interface BalloonsControllerGetBalloonsByEventId$Params {
  eventId: number;
}

export function balloonsControllerGetBalloonsByEventId(http: HttpClient, rootUrl: string, params: BalloonsControllerGetBalloonsByEventId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DbrBalloonEntity>>> {
  const rb = new RequestBuilder(rootUrl, balloonsControllerGetBalloonsByEventId.PATH, 'get');
  if (params) {
    rb.path('eventId', params.eventId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DbrBalloonEntity>>;
    })
  );
}

balloonsControllerGetBalloonsByEventId.PATH = '/balloons/{eventId}';
